import React, { Component } from 'react';
import Amplify from 'aws-amplify';
import AppRouter from './AppRouter';
import Spinner from './Components/Theme/Spinner';
import { connect } from 'react-redux';
import * as authActions from './redux/actions/authActions';
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import AWSMobile from './aws-exports';

const PRODUCTION_MFA_URL = 'https://d3n4eycido58nz.cloudfront.net/';
//dev da2-mgadwqto4vgbfoldpuk4aysw5q
//qa da2-sa47gsnl7bfs5fcrxkqxifoz5u 
//stg da2-w3nugft3yfdm7gqqfa5strybuq
//prod da2-nl5owmbcjnhvrlmgwfpvqaffhe
Amplify.configure({
  API: {
    graphql_endpoint: AWSMobile.aws_appsync_graphqlEndpoint,
    graphql_headers: async () => ({
      'x-api-key': "da2-w3nugft3yfdm7gqqfa5strybuq"
    })              
  }
});


const redirectSignIn = window.location.origin;
export class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authState: 'initialPageLoad'
    }
  }

  async componentDidMount() {
    const code = this.getQueryParams().code;
    if (!this.props.user.login && code ) {
      this.setState({
      authState: 'backfromFSSWaitingForClaim'
      });
      console.log(`code is ${code}`)
      await this.props.actions.fetchAuth(code)
         .catch(error => {
          alert("Fetch Auth failed\n" + JSON.stringify(error));
        });
      const { sso } = await this.props.auth;
      //onst sso = '206647428';
      //const sso = '502101080';  //Josue
      //const sso = '206408475' //Raul

      await this.props.actions.fetchUserSession(sso).catch(error => {
        alert("Fetch User Session failed\n" + JSON.stringify(error));
      });

      this.adminMFAValidation(this.props.user);

      this.setState({
        authState: 'signedIn'
      });
    }

    if (!this.props.user.login && !code) {
        this.redirectToFSS();
    }
    if (this.props.user.login) {
      // prevent user from hitting browser back-button after adminEnvRedirect
      if (this.props.user.adminEnvRedirect.result && this.checkNotMFAOrigin()) {
        window.location.href = PRODUCTION_MFA_URL; // prod-mfa environment
      }
      this.setState({
        authState: 'signedIn'
      });
    }
  }

  redirectToFSS = () => {
    const redirectSignIn = window.location.origin;
    const MFAScope = 'NoMFA';  // non-MFA = 'NoMFA'  MFA = 'AlwaysMFAEnabled'
    //Non prod
    window.location.href = `https://fss.stg.inbcu.com/fss/as/authorization.oauth2?client_id=Storm-Dev&response_type=code&scope=openid+profile+${MFAScope}&redirect_uri=${redirectSignIn}/`;

    //prod
    //window.location.href = `https://fss.inbcu.com/fss/as/authorization.oauth2?client_id=Storm-Dev&response_type=code&scope=openid+profile+${MFAScope}&redirect_uri=${redirectSignIn}/`;

  };

  getQueryParams = () => {
    let queryParams = {};
    //create an anchor tag to use the property called search
    let anchor = document.createElement('a');
    //assigning url to href of anchor tag
    anchor.href = window.location.href;
    //search property returns the query string of url
    let queryStrings = anchor.search.substring(1);
    let params = queryStrings.split('&');

    for (let i = 0; i < params.length; i++) {
        let pair = params[i].split('=');
        queryParams[pair[0]] = decodeURIComponent(pair[1]);
    }
    return queryParams;
  }

  // redirect admin users to prod-mfa env in production
  adminMFAValidation = async (user) => {
    if (user.adminEnvRedirect.result && this.checkNotMFAOrigin() ) {
      alert('You are an admin and are now being redirected to the admin production environment.');
      window.location.href = PRODUCTION_MFA_URL; // prod-mfa environment
    }
  }

  checkNotMFAOrigin = () => {
    let regex = new RegExp(PRODUCTION_MFA_URL);
    return !regex.test(window.location.href)
  }


  render() {
    const { authState } = this.state;
    const { user, auth } = this.props;
    console.log(`authState: ${authState}`);
    return (
        <div className="App">
          {
            (authState === 'signedIn' && this.props.user.login)
            ? <AppRouter/>
            : <Spinner />
          }
        </div>
    );
  }
}

App.propTypes = {
  actions: PropTypes.object.isRequired,
  auth: PropTypes.object,
  user: PropTypes.object
};

function mapStateToProps(state) {
  return {
      auth: state.auth,
      user: state.user
  };
}

function mapDispatchToProps(dispatch) {
  return {
      actions: {
          fetchAuth: bindActionCreators(
              authActions.fetchAuth,
              dispatch
          ),
          fetchUserSession: bindActionCreators(
            authActions.fetchUserSession,
            dispatch
        ),
      }
  };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
   )(App);






// WEBPACK FOOTER //
// ./src/App.js